import { ScrollColumnView } from '@ipfabric/ui-components/ScrollView/ScrollColumnView';
import type { LoadingState } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import type {
  BuiltInIntentVerificationRuleSummary,
  IntentRuleId,
} from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import classNames from 'classnames';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { checkIntent } from 'components/Graph/commands/checkIntent';
import { SeverityCountsListItem } from 'components/SeverityCounts/SeverityCountsListItem';
import { useLocale } from 'containers/App/LocaleContext';
import { useMemo } from 'react';
import type { FC } from 'react';

interface Props {
  data: {
    loadingState: LoadingState;
    summary: BuiltInIntentVerificationRuleSummary | null;
  };
  selectedIntentRuleId: IntentRuleId | null;
}

export const BuiltInRulesList: FC<Props> = (props) => {
  const msg = useLocale();
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  const items = useMemo(() => {
    const list = props.data.summary?.list ?? [];

    return list.map((item) => (
      <SeverityCountsListItem
        className={classNames(
          'severity-counts-list-item--intents',
          props.selectedIntentRuleId === item.id &&
            'severity-counts-list-item--intents-selected',
        )}
        key={item.id}
        name={item.name}
        counts={item.results}
        onClick={() => {
          ctxProps.dispatch(checkIntent, {
            intentRule: item.id,
          });
        }}
      />
    ));
  }, [props.data, props.selectedIntentRuleId, ctxProps.dispatch]);

  return (
    <ScrollColumnView>
      {props.data.summary && items.length === 0 && (
        <div className='pt-lgu-10 mx-5 flex flex-col items-center'>
          {
            msg.canvasGraph.graphSidePanel.intentVerification
              .noBuiltInChecksForDevices
          }
        </div>
      )}
      <div className='intent-verification-list'>{items}</div>
    </ScrollColumnView>
  );
};
